import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {UserListWrapper} from './users-list/UserList'
import {PageLink, PageTitle} from '../../../../template/_metronic/layout/core'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../redux/store'
import {hasPermission} from '../../../../helpers/utilities'
import {Error404} from '../../errors/components/Error404'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'User Management',
    path: '/user-management/list',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const UsersPage = () => {
  const currentUser = useSelector((state: RootState) => state.authSlice.user)
  const hasListFriBusinessPermission = hasPermission(currentUser, 'list_user')
  return (
    <Routes>
      <Route element={<Outlet />}>
        {hasListFriBusinessPermission ? (
          <Route
            path='list'
            element={
              <>
                <PageTitle breadcrumbs={usersBreadcrumbs}>Users list</PageTitle>
                <UserListWrapper />
              </>
            }
          />
        ) : (
          <Route path='list' element={<Error404 />} />
        )}
      </Route>
      <Route index element={<Navigate to='/user-management/list' />} />
    </Routes>
  )
}

export default UsersPage
